export default __webpack_public_path__ + "static/media/Ballroll_00031.cc97ba7b.png";